import "core-js/modules/es.array.reverse.js";
import _styled from "styled-components";
var _dec, _class, _class2;
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
import "!!style-loader!css-loader!./sortable.css";
import { action, makeObservable } from "mobx";
import { observer } from "mobx-react";
import { Component } from "react";
import Sortable from "react-anything-sortable";
import styled from "styled-components";
import { Ul } from "../../Styled/List";
import WorkbenchItem from "./WorkbenchItem";
import WorkbenchSplitScreen from "./WorkbenchSplitScreen";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const StyledUl = styled(Ul).withConfig({
  displayName: "WorkbenchList__StyledUl",
  componentId: "sc-ytfe7c-0"
})(["gap:5px;margin:15px 0;padding:0 15px;li{&:first-child{margin-top:0;}}"]);
let WorkbenchList = (_dec = action.bound, observer(_class = (_class2 = class WorkbenchList extends Component {
  constructor(props) {
    super(props);
    makeObservable(this);
  }
  onSort(_sortedArray, currentDraggingSortData, currentDraggingIndex) {
    this.props.terria.workbench.moveItemToIndex(currentDraggingSortData, currentDraggingIndex);
  }
  render() {
    return /*#__PURE__*/_jsxs(StyledUl, {
      overflowY: "auto",
      overflowX: "hidden",
      scroll: true,
      fullWidth: true,
      column: true,
      flex: "1",
      children: [this.props.terria.showSplitter && /*#__PURE__*/_jsx(WorkbenchSplitScreen, {
        terria: this.props.terria
      }), /*#__PURE__*/_jsx(_StyledSortable, {
        onSort: this.onSort,
        direction: "vertical",
        dynamic: true,
        children: this.props.terria.workbench.items.map(item => {
          return /*#__PURE__*/_jsx(WorkbenchItem, {
            item: item,
            sortData: item,
            viewState: this.props.viewState
          }, item.uniqueId);
        })
      })]
    });
  }
}, _applyDecoratedDescriptor(_class2.prototype, "onSort", [_dec], Object.getOwnPropertyDescriptor(_class2.prototype, "onSort"), _class2.prototype), _class2)) || _class);
export default WorkbenchList;
var _StyledSortable = styled(Sortable).withConfig({
  displayName: "WorkbenchList___StyledSortable",
  componentId: "sc-ytfe7c-1"
})(["width:100%;"]);